<template>
  <v-container fluid class="investstock-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/investstock/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="investstocks-table"
              show-select
              single-select
              item-key="_id"
              sort-by="stockrank"
              :footer-props="footer"
              :headers="headers"
              :items="stocks"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this stock?
                    </v-card-title>

                    <v-card-text>
                      {{ delete_stock.stockname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_stock)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.stockimage="{ item }">
                    <v-img
                    v-if="item.stockimage" 
                    v-bind:src="item.stockimage"
                    max-height="80"
                    max-width="80"
                  ></v-img>
              </template>
              <template v-slot:item.stockname="{ item }">
                <p class="two-line"><a class="primaryConst--text">{{ item.investstockcode }}</a></p>
                <p class="two-line"><a class="primaryConst--text">{{ item.stockname }}</a></p>
                <p class="two-line">{{ item.investstockinfo }}</p>
              </template>
              <template v-slot:item.stockstatus="{ item }">
                <v-chip
                  :color="getStatusColor(item.stockstatus)"
                  small>
                  {{ item.stockstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config";
import { mapState, mapActions } from 'vuex';
import { getStatusColor } from '../../../util/tools';

export default {
  name: 'investstockList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      delete_stock: {},
      headers: [
        { text: 'Image', value: 'stockimage', sortable: false, width: '10%' },
        { text: 'Rank', value: 'stockrank', width: '6%'},
        { text: 'Type', value: 'stocktype', width: '10%'  },
        { text: 'Code', value: 'stockcode', width: '8%' },
        { text: 'Name', value: 'stockname' },
        { text: 'Status', value: 'stockstatus', width: '10%'  },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('InvestStock', ['stocks', 'isReceiving', 'isDeleting', 'idToDelete', 'stocksMessage', 'isUpdating']),
  },
  methods: {
    ...mapActions('InvestStock', ["getInvestStocksRequest","deleteInvestStockRequest","updateInvestStockRequest","createInvestStockRequest"
    ]),
    editItem(item) {
      this.$router.push({ name: 'InvestStockEdit', params: item })
    },
    deleteItem(item) {
      this.deleteInvestStockRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.delete_stock = {
        _id: item._id,
        stockname: item.stockname,
      }
    },
  },
  async created () {
    await this.getInvestStocksRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
